import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, RouteComponentProps, Switch } from 'react-router';
import { FeaturedForeignLanguageEntryPage } from './FeaturedForeignLanguageEntryPage';
import { LanguageLearningProductsPage } from './allproducts/LanguageLearningProductsPage';
import { CheckLoanFormat } from '../../../shared/components/CheckLoanFormat';

const LanguageLearningRouteSwitch: FC<RouteComponentProps> = ({ match: { path, url } }) => {
    return (
        <Switch>
            <Route
                path={`${path}/:languageId/products/:loanFormat`}
                render={() => (
                    <CheckLoanFormat>
                        <LanguageLearningProductsPage />
                    </CheckLoanFormat>
                )}
            />

            {/* PORTAL-3993 redirect all pages to products */}
            <Redirect path={`${path}/:languageId/products`} to={`${path}/:languageId/products/all`} />
            <Redirect from={`${path}/:languageId/featured`} to={`${path}/:languageId/products/all`} />
            <Redirect from={`${path}/:languageId/newlyadded`} to={`${path}/:languageId/products/all`} />

            <Route
                path={`${path}/:loanFormat`}
                render={() => (
                    <CheckLoanFormat>
                        <FeaturedForeignLanguageEntryPage />
                    </CheckLoanFormat>
                )}
            />

            <Redirect from={path} to={`${url}/all`} />
        </Switch>
    );
};

export default LanguageLearningRouteSwitch;
